var map = {
	"./ETH.png": 1207,
	"./arrow-right.svg": 1208,
	"./binance-wallet.svg": 1209,
	"./certik-logo-w.png": 726,
	"./empty-token.png": 1210,
	"./flags/cn.png": 426,
	"./flags/kr.png": 427,
	"./flags/uk.png": 425,
	"./flags/us.png": 424,
	"./icon.png": 1211,
	"./logo-h-dark.svg": 502,
	"./logo-h.svg": 503,
	"./metamask-dark.png": 1212,
	"./metamask-icon.png": 613,
	"./metamask.png": 1213,
	"./moon.png": 498,
	"./splash.png": 1214,
	"./standardHashrate-dark.png": 611,
	"./standardHashrate.png": 612,
	"./sun.png": 499,
	"./tronlink.png": 1215,
	"./walletConnectIcon.svg": 1216,
	"./webbg.jpg": 358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;